import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API } from "../App";

/**
 * useTaxonomy(kind) — fetches the active (non-deleted) items for a
 * given taxonomy kind. Returns {items, loading, refetch}.
 *
 * Member-facing dropdowns should read from this hook instead of using
 * hardcoded constants so admin Manage-list edits show up immediately.
 *
 * Items have the shape {taxonomy_id, key, label, order}.
 */
export const useTaxonomy = (kind) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    if (!kind) return;
    setLoading(true);
    try {
      const res = await axios.get(`${API}/taxonomy/${kind}`);
      setItems(res.data.items || []);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [kind]);

  useEffect(() => { refetch(); }, [refetch]);

  return { items, loading, refetch };
};
